export type ControleProjetoStatus = "rascunho" | "planejado" | "ativo" | "encerrado" | "renovado";

/** Vaga fixa não tem data final; frila tem (controle_projetos.modalidade, sql/308). */
export type ProjetoModalidade = "frila" | "fixa";

export const CONTROLE_PROJETO_STATUS_LABEL: Record<ControleProjetoStatus, string> = {
  rascunho: "Rascunho",
  planejado: "Planejado",
  ativo: "Ativo",
  encerrado: "Encerrado",
  renovado: "Renovado",
};

export interface ControleProjetoAvaliacao {
  id: string;
  status: string;
  rating: number;
  media_geral?: number;
  feedback_text: string;
  feedback_data: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  completed_at: string;
  evaluator_type?: "freelancer" | "agency";
  deleted_at?: string | null;
}

export interface ControleProjeto {
  id: string;
  agencia_id: string;
  freelancer_id: string;
  area_atuacao: string;
  area_canonica?: string | null;
  nucleo?: string | null;
  data_inicio: string | null;
  data_conclusao: string | null;
  created_at: string;
  updated_at?: string;
  deleted_at?: string | null;
  valor_projeto?: number | null;
  numero_renovacoes?: number;
  projeto_original_id?: string | null;
  vaga_id?: string | null;
  status?: ControleProjetoStatus;
  modalidade?: ProjetoModalidade;
  agencia?: { nome: string; email?: string };
  freelancer?: { nome: string; email?: string };
  job_evaluations?: ControleProjetoAvaliacao[];
  freelancer_evaluation?: ControleProjetoAvaliacao;
  agency_evaluation?: ControleProjetoAvaliacao;
  /** Só no cliente: renovações planejadas da cadeia, em ordem (anexarPlanejados). */
  planejados?: ControleProjeto[];
}
